import React, { useEffect, useState } from 'react';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import styles from './SendEmailNode.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import SendEmailModal from './send-email-modal/SendEmailModal';

const SendEmailNode = ({ id, selected, onNodesDelete, data, ...props }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isError, setIsError] = useState(node?.is_Error || false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (node?.message) {
      if (!node?.message?.message || node?.message?.message === '<p><br></p>') {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.message]);

  console.log('node: ', node);

  return (
    <>
      <NodeContainer
        name={node.title || 'Email'}
        id={id}
        onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        onNodesDelete={onNodesDelete}
        node={node}
        isError={isError}
      >
        <Handle
          className='custom-handle'
          type='target'
          position={Position.Left}
        />
        <div className={styles['node-container']}>
          <div className={styles['svg-container']}>
            <SvgWithBranding type='telegram' />
            <p className={styles['send-to']}>Sent to:</p>
          </div>
          {node?.message?.to && (
            <div className={styles['number-container']}>
              <p>{node?.message?.to}</p>
            </div>
          )}
          <hr className={styles['separator']} />
          {node?.message?.subject && (
            <p className={styles['subject']}>{node?.message?.subject}</p>
          )}
          {node?.message?.message == undefined ||
          node?.message?.message == '' ||
          node?.message?.message == '<p><br></p>' ? (
            <>
              <hr className={styles['separator']} />

              <p className={styles.placeholder}>Enter a message</p>
            </>
          ) : (
            <>
              <hr className={styles['separator']} />

              <p
                className={styles['message-preview']}
                dangerouslySetInnerHTML={{ __html: node?.message?.message }}
              ></p>
            </>
          )}
        </div>

        <Handle
          type='source'
          className='custom-handle'
          position={Position.Right}
        />
      </NodeContainer>

      <SendEmailModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Email'
        id={id}
        isError={isError}
      />
    </>
  );
};

export default SendEmailNode;
